import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  list: [],
  pageInfo: {
    page: 1,
    totalPage: 2
  },
  condition: {

    userNo: 0,
    page: 1,
    limit: 10,
    storeNo: '',
    searchText: '',
    regDate: '',
    startDate: '',
    endDate: ''
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
